import React from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import './EyeIcon.css'

export default function EyeIcon({ onClick, expanded = false }) {
  return (
    <button className="button-border" onClick={onClick}>
      <div className="icon-wrapper">
        {expanded ? (
          <VisibilityOffIcon className="eye-icon" />
        ) : (
          <VisibilityIcon className="eye-icon" />
        )}
      </div>

    </button>
  );
}